import { IOrder } from '@jobcost-monorepo/crud';
import { ScheduledOrder } from './types';
import dayjs from '@jobcost-monorepo/dayjs-config';

export function manipulateOrders(
  data: IOrder[],
  startDate: string,
  endDate: string,
): ScheduledOrder[] {
  const result: ScheduledOrder[] = [];
  const ordersByMonth: { [key: string]: IOrder[] } = {};

  const addMonths = (date: Date, months: number): Date => {
    const d = new Date(date);
    d.setMonth(d.getMonth() + months);
    return d;
  };

  for (const order of data) {
    const orderStart = order.startDate ? dayjs.utc(order.startDate) : null;
    const orderEnd = order.endDate ? dayjs.utc(order.endDate) : null;
    let currentDate = dayjs.utc(startDate);

    while (
      currentDate.isBefore(endDate) ||
      currentDate.isSame(endDate, 'month')
    ) {
      const monthAndYear = currentDate.format('YYYY-MM');
      if (
        orderStart &&
        orderEnd &&
        currentDate.isBetween(orderStart, orderEnd, 'month', '[]')
      ) {
        if (!ordersByMonth[monthAndYear]) {
          ordersByMonth[monthAndYear] = [];
        }
        ordersByMonth[monthAndYear].push(order);
      }
      currentDate = dayjs.utc(addMonths(currentDate.toDate(), 1));
    }
  }

  for (const monthAndYear in ordersByMonth) {
    result.push({
      monthAndYear,
      orders: ordersByMonth[monthAndYear],
    });
  }

  return result;
}
